import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { addVideoBlob, addVideoBlobAvatars, addVideoBlobBefore } from '../../store/videoSlice';

export default function VideoToBlob({ step, steps }) {

    const dispatch = useDispatch();

        const videosBefore= [
        { id: 'avatar-video-07', video: '/video/video-avatars/cream-video-01.mp4'},
    ];



    const videoBlobsBefore = useSelector((state) => state.videos.blobsBefore);
    useEffect(() => {
        const loadVideosToBlob = async () => {
            const currentStepIndex = steps.findIndex((s) => s.id === step.id);
            if (currentStepIndex === -1) return;
            for (const video of videosBefore) {
                if(videoBlobsBefore[video.id]) continue;
                const videoStepIndex = steps.findIndex((s) => s.id === 'video-reason');
                if (currentStepIndex > videoStepIndex - 3 && currentStepIndex <= videoStepIndex) {
                    try {
                        console.log(`Loading video: ${video.id}`);
                        const response = await fetch(video.video);
                       
                        if (!response.ok) {
                            throw new Error(`Failed to load video: ${video.video}`);
                        }

                        const blob = await response.blob();
                        const blobUrl = URL.createObjectURL(blob)
                        dispatch(addVideoBlobBefore({ id: video.id, blobUrl}));
                    } catch (error) {
                        console.error(`Error loading video ${video.id}:`, error);
                    }
                }
            }
        };
        loadVideosToBlob();
    }, [dispatch, step]);


    const videosAvatars = [
        { id: 'avatar-video-04', video: '/video/video-avatars/avatar-video-04.mp4' },
        { id: 'avatar-video-05', video: '/video/video-avatars/avatar-video-05.mp4' },
        { id: 'avatar-video-03', video: '/video/video-avatars/avatar-video-03.mp4' },
        { id: 'avatar-video-02', video: '/video/video-avatars/avatar-video-02.mp4' },
        { id: 'avatar-video-01', video: '/video/video-avatars/avatar-video-01.mp4' },
        { id: 'avatar-video-06', video: '/video/video-avatars/avatar-video-06.mp4' },
    ];



    const videoBlobsAvatars = useSelector((state) => state.videos.blobsAvatars);
    useEffect(() => {
        const loadVideosToBlob = async () => {
            const currentStepIndex = steps.findIndex((s) => s.id === step.id);
            if (currentStepIndex === -1) return;
            for (const video of videosAvatars) {
                if(videoBlobsAvatars[video.id]) continue;
                const videoStepIndex = steps.findIndex((s) => s.id === 'video-ads');
                if (currentStepIndex > videoStepIndex - 3 && currentStepIndex <= videoStepIndex) {
                    try {
                        console.log(`Loading video: ${video.id}`);
                        const response = await fetch(video.video);
                        if (!response.ok) {
                            throw new Error(`Failed to load video: ${video.video}`);
                        }
                        const blob = await response.blob();
                        const blobUrl = URL.createObjectURL(blob)
                        dispatch(addVideoBlobAvatars({ id: video.id, blobUrl}));
                    } catch (error) {
                        console.error(`Error loading video ${video.id}:`, error);
                    }
                }
            }
        };
        loadVideosToBlob();
    }, [dispatch, step]);




    const videos = [
        {
            id: 'video-templates',
            video: '/video/animation/Dynamic templates.mp4',
        }, {
            id: 'video-scripts',
            video: '/video/animation/Conversion_Scripts.mp4',
        }, {
            id: 'video-hooks',
            video: '/video/animation/Hooks_&_CTAs.mp4',
        }, {
            id: 'video-conversion',
            video: '/video/animation/Conversion-focused_cursor.mp4',
        }, {
            id: 'static-templates',
            video: '/video/animation/100+ proven templates.mp4',
        }, {
            id: 'static-text',
            video: '/video/animation/AI-Powered_Content.mp4',
        },
        {
            id: 'static-editor',
            video: '/video/animation/Drag_n_Drop_Editing.mp4',
        },
        {
            id: 'static-bulk',
            video: '/video/animation/Bulk_Ad_Creation.mp4',
        },
        {
            id: 'ad-campaigns',
            video: '/video/animation/Smart_AI_Campaigns 1.mp4',
        },
        {
            id: 'ad-targeting',
            video: '/video/animation/AI_Audience_Targeting.mp4',
        }, {
            id: 'ad-optimization',
            video: '/video/animation/AI_Ads_Optimisations.mp4',
        }, {
            id: 'ad-reports',
            video: '/video/animation/Real-time_ad_reports.mp4',
        }, {
            id: 'ad-copilot',
            video: '/video/animation/AI_copilot.mp4',
        },
    ]

    const videoBlobs = useSelector((state) => state.videos.blobs);

    useEffect(() => {
        const loadVideosToBlob = async () => {
            const currentStepIndex = steps.findIndex((s) => s.id === step.id);
            if (currentStepIndex === -1) return;
            for (const video of videos) {
                const videoStepIndex = steps.findIndex((s) => s.id === video.id);
                if(videoBlobs[video.id]) continue;
                if (currentStepIndex > videoStepIndex - 3 && currentStepIndex <= videoStepIndex) {
                    try {
                        console.log(`Loading video: ${video.id}`);
                        const response = await fetch(video.video);
                        if (!response.ok) {
                            throw new Error(`Failed to load video: ${video.video}`);
                        }

                        const blob = await response.blob();
                        dispatch(addVideoBlob({ id: video.id, blob }));
                    } catch (error) {
                        console.error(`Error loading video ${video.id}:`, error);
                    }
                }
            }
        };
        loadVideosToBlob();
    }, [dispatch, step]);


    return (
        <></>
    )
}
